<template>
    <v-col
      cols="12"
      md="5"
    >
    <slot></slot>
  </v-col>
</template>

<script>
export default {
  name: "Col5"
}
</script>

<style scoped>

</style>